import { useEffect } from "react";
import i18n from "@/lib/i18n";
import { useGlobalUserInfo } from "@/providers/AuthProvider";

/**
 * ユーザープロファイルの言語設定とアプリケーションの表示言語を同期するフック
 * このフックはアプリケーションの起動時やユーザー情報の更新時に
 * ユーザープロファイルの言語設定に基づいて表示言語を設定します
 */
export const useLanguageSync = () => {
  const userInfo = useGlobalUserInfo();

  useEffect(() => {
    // ユーザー情報が取得できた場合、言語設定を適用
    if (
      userInfo?.account?.language &&
      userInfo.account.language !== i18n.language
    ) {
      i18n.changeLanguage(userInfo.account.language);
    }
  }, [userInfo]);

  return null;
};
